import React, {useState} from 'react';

import './VaultCreate.scss';
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import VaultForm from "../VaultForm/VaultForm";
import {compose} from "redux";
import {connect} from "react-redux";
import {toggleLoading} from "../../redux/reducers/utils";
import {Helmet} from "react-helmet";
import VaultCreateModal from "./modals/VaultCreateModal";

function VaultCreate(props) {

  let [openVaultCreateModal, setOpenVaultCreateModal] = useState(false);
  let [vault, setVault] = useState();

  props.toggleLoading(false);

  const saveVault = (vault) => {
    setVault(vault);
    setOpenVaultCreateModal(true);
  };

  return (
    <>
      <Helmet>
        <title>Fidelius Vaults: Create New Vault</title>
      </Helmet>
      <Paper className="create-vault-container m-auto overflow-y-auto">
        <p className="font-bold text-3xl lg:text-5xl text-center">Create New Vault</p>
        <p className="text-sm lg:text-base text-center text-grey mt-2 sm:mt-0 mb-4">For help with creating a vault, or details about Fidelius Guardian Approval Protocol, <a target="_blank" href={"https://www.fideliusvaults.com/faq/"}>visit our FAQ</a>.</p>
        <Divider variant="middle"/>
        <VaultForm saveVault={saveVault} client={props.client}/>
      </Paper>

      <div className="vault-create-modal-container">
        <VaultCreateModal open={openVaultCreateModal}
                          vault={vault}
                          close={() => setOpenVaultCreateModal(false)}/>
      </div>
    </>
  );
}


export default compose(
  connect(
    null,
    { toggleLoading }
  )
)(VaultCreate);
